import { Component } from '@angular/core';
import { MenuController,  Platform, IonicModule } from '@ionic/angular';
import { EmitEvent, EventBusService } from './services/event-bus.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { PushNotificationSchema, ActionPerformed, PushNotifications, Token } from '@capacitor/push-notifications';

import { environment } from '../environments/environment';
import { LocalStorageService } from './services/local-storage';
import { Router } from '@angular/router';

import * as _ from 'lodash';
import { MessageService } from './services/message.service';
import { App } from '@capacitor/app';
import { UserService } from './core/user/user.service';
import { MatButtonModule } from '@angular/material/button';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    imports: [IonicModule, MatButtonModule]
})
export class AppComponent {
  appVersion: string = '12';
  avatar: string;
  username: string;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  PushRegistrationListener: any;
  PushRegistrationErrorListener: any;

  PushNotificationReceivedListener: any;
  PushNotificationActionPerformedListener: any;
  LocalPushNotificationActionPerformedListener: any;

  constructor(
    private platform: Platform,
    private router: Router,
    private menu: MenuController,
    private storage: LocalStorageService,
    private messageService: MessageService,
    private eventBusService: EventBusService,
    private userService: UserService,
  ) {
    this.initializeApp();
  }

  async initializeApp() {
    this.platform.ready().then(() => {
      SplashScreen.hide();

      this.userService.user$.subscribe({
        next: (user) => {
          this.avatar = user.avatar;
          this.username = user.name;
        },
      });
    });

    this.platform.backButton.subscribeWithPriority(10, (processNextHandler) => {
      document.addEventListener(
        'ionBackButton',
        (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
        },
        false,
      );
    });

    this.setupDefaults();
    this.setupEvents();

    if (Capacitor.isNativePlatform()) {
      this.setupPushNotification();
    }
  }

  ionViewDidEnter() {
  }

  async setupDefaults() {
    if (Capacitor.isNativePlatform()) {
      App.getInfo().then((res) => {
        this.appVersion = res.version;
      });
    } else this.appVersion = environment.version;

    try {
      const supportedLangs = ['en', 'es'];
      const browserLang = navigator.language.substr(0, 2);

      let lang = await this.storage.getLang();

      if (_.isEmpty(lang) && supportedLangs.indexOf(browserLang) !== -1) {
        lang = browserLang;
      }

      lang = lang || environment.defaultLang;

      this.storage.setLang(lang);
    } catch (error) {
      console.error(error);
    }
  }

  setupEvents() {
    this.eventBusService.on('user:profileUpdate', () => {
    });

    this.eventBusService.on('user:logout', () => {
      this.signOut();
    });

    this.eventBusService.on('user:login', (user: any) => {
    });

    this.eventBusService.on('app:CheckRegisterPush', async () => {
      if (Capacitor.isNativePlatform()) {
        this.registerNotifications();
      }
    });
  }

  async registerNotifications() {
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
      throw new Error('User denied permissions!');
    }

    await PushNotifications.register();
  }

  navToRoute(route) {
    this.router.navigate([route]);
    this.menu.close();
  }

  async signOut(): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      await PushNotifications.removeAllListeners();

      this.PushRegistrationListener = null;
      this.PushRegistrationErrorListener = null;
      this.PushNotificationReceivedListener = null;
      this.PushNotificationActionPerformedListener = null;
      this.LocalPushNotificationActionPerformedListener = null;
    }

    this.menu.close();
    this.router.navigate(['/sign-out']);
  }

  goTo(page: string) {
    this.router.navigate([page]);
  }

  getApiUrl(path) {
    const url = environment.baseUrl + path;

    Browser.open({ url: url });
  }

  async RegisteDevice(token: string, deviceArn) {
    console.log("🚀 ~ AppComponent ~ RegisteDevice ~ deviceArn:", deviceArn)
    console.log("🚀 ~ AppComponent ~ RegisteDevice ~ token:", token)
    
    if (token != null && token?.length > 0) {
      let userId = await this.storage.getStorage<string>('IdUser');
      console.log("🚀 ~ AppComponent ~ RegisteDevice ~ userId:", JSON.stringify(userId));

      this.messageService.RegisterDevice(userId, token, Capacitor.getPlatform(), deviceArn)
      .pipe(takeUntil(this._unsubscribeAll)).subscribe({
        next: (res) => {},
        error: (err) => {
        console.log("🚀 ~ AppComponent ~ RegisteDevice ~ err:", JSON.stringify(err))
        }});

      // this.messageService.RegisterDevice(userId, token, Capacitor.getPlatform(), deviceArn).then(
      //   (res) => {},
      //   (err) => {
      //   },
      // );
    }
  }

  async setupPushNotification() {
    await PushNotifications.addListener('registration', (token: Token) => {
      this.RegisteDevice(token.value, '');
    });

    await PushNotifications.addListener('registrationError', (err) => {
      console.error('Registration error: ', JSON.stringify(err));
    });

    await PushNotifications.addListener('pushNotificationReceived', async (notification: PushNotificationSchema) => {
      console.log('Push notification received: ' + JSON.stringify(notification));
      await this.messageService.getMessages();
      this.ProcessNotification(notification);
    });

    await PushNotifications.addListener('pushNotificationActionPerformed', async (notification: ActionPerformed) => {
      console.log('Push action performed: ' + JSON.stringify(notification.notification));

      const data = notification.notification.data;
      // this.navigate_chat(data, true);
    });
  }

  async ProcessNotification(notification: PushNotificationSchema) {
    let noti = null;

    this.eventBusService.emit(new EmitEvent('signal:new'));

    if (notification.data && notification.data?.payload) {
      noti = JSON.parse(notification.data.payload);
    }

    this.eventBusService.emit(new EmitEvent('tabs:checkMessages'));
  }

  async terms(): Promise<void> {
    await Browser.open({ url: 'https://profit4u.club/terms' });
  }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    PushNotifications.removeAllListeners();
  }
}
